module.exports = __webpack_public_path__ + "static/gallery1-3e5852a4340169126e2d0360cd5f88fd.jpg";